import { tv } from 'tailwind-variants';

export const defaultVariants = tv({
  slots: {
    wrapper: [
      'bg-light-gray',
      'p-4',
      'flex',
      'flex-col',
      'justify-center',
      'items-center',
      'gap-2',
      'md:flex-row',
      'md:gap-7.5',
      'rounded-sm',
    ],
    lastUpdated: [
      'flex-1',
      'font-light',
      'text-base leading-normal text-textPrimary',
      'text-center',
    ],
    actionWrapper: ['flex-1', 'flex', 'justify-center', 'w-full'],
    subscribeButton: ['w-full', 'md:w-fit', 'gap-2', 'text-base leading-normal'],
  },
  variants: {
    alignment: {
      paired: {
        lastUpdated: ['md:text-left'],
        actionWrapper: ['md:justify-end'],
      },
      centered: {
        lastUpdated: ['md:text-center'],
        actionWrapper: ['md:justify-center'],
      },
    },
  },
  defaultVariants: {
    alignment: 'paired',
  },
});
